import React, { useCallback, useEffect, useState } from "react";
import { Spin, Select, Form, Button, Table, notification } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getProductClass } from "../../redux/actions/productClass.action";
import { getFitCategory } from "../../redux/actions/fitCategory.action";
import { getSeason } from "../../redux/actions/season.action";
import { getGender } from "../../redux/actions/gender.action";
import { getSize } from "../../redux/actions/size.action";
import { getSku } from "../../redux/actions/sku.action"
import { ReadCookie } from "../../utils/readCookie";
import { getStyle } from "../../redux/actions/style";
import moment from "moment";
import btnPrint from "../../assets/images/button_print.gif";
import xlsx from "../../assets/images/ico_xls_sm.gif";
import logo from "../../assets/images/logo.png";
import "../Distributor/Distributor.css";
import Loader from "react-loader-spinner";
import { getWashName } from "../../redux/actions/wash.action";
import { useRef } from "react";
import { getProductionReason, getProductionUnFinished, productionReport } from "../../redux/actions/productionReport.action";
import numeral from "numeral";
import { CSVLink } from "react-csv";
import { TabTitle } from "../../utils/GeneralFunction";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import filterHelper, { sorterHelper } from "../../utils/filterHelper";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const { Option } = Select;


const ProductionUnFinished = ({ token }) => {
  TabTitle("Production UnFinished")
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const {
    style,
    gender,
    season,
    styleChange,
    Sku,
    wash,
    productionUnFinished,
    productionReason
  } = useSelector((state) => state);
  const menuId = ReadCookie("menuId");
  const userName = ReadCookie("name");
  const tableRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [productionList, setProductionList] = useState([]);
  const [excelData, setExcelData] = useState([])
  const [isGenerate, setIsGenerate] = useState("All");
  const [isSKU, setIsSKU] = useState("All");
  const [paginationInfo, setPaginationInfo] = useState({
    current: 1,
    pageSize: 500,
    total: 0,
  });
  function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }

  let query = useQuery();
  let query_sku = query.get("sku");


  useEffect(() => {
    if (query_sku) {
      const values = {
        sku: query_sku
      }
      form.setFieldsValue({
        sku: values.sku,
      });
      setLoading(true)
      dispatch(getProductionUnFinished(token, values)).then((res) => {
        setLoading(false)
        setProductionList(res?.payload?.data);
        downloadExcelFileData(res?.payload?.data);
      });
    }
  }, [query_sku])

  const onFinish = async (e) => {
    setLoading(true)
    await form.validateFields().then((data) => {
      dispatch(getProductionUnFinished(token, data)).then((res => {
        setLoading(false)
        setProductionList(res?.payload?.data);
        downloadExcelFileData(res?.payload?.data);
      }));
    });
  };

  useEffect(() => {
    dispatch(getStyle(token, menuId));
    dispatch(getSeason(token, menuId));
    dispatch(getProductClass(token, menuId));
    dispatch(getSize(token, menuId));
    dispatch(getGender(token, menuId));
    dispatch(getWashName(token, menuId));
    dispatch(getFitCategory(token, menuId));
    dispatch(getProductionReason(token));
  }, [dispatch, menuId, token]);

  const handlePrint = () => {
    const totalPages = Math.ceil(productionList?.length / paginationInfo?.pageSize);
    console.log(totalPages, "totalPages");
    let notificationKey = "print-warning";
    if (totalPages > 1) {
      notification.warning({
        message: "Printing Notice",
        description: `Data has ${totalPages} pages. Only page ${paginationInfo.current} will be printed.`,
        duration: 2,
        key: notificationKey,
      });
      setTimeout(() => {
        notification.close(notificationKey);
      }, 2000);
      setTimeout(() => {
        notification.close(notificationKey);
        const css = "@page { margin-top: 30px; margin-bottom: 30px }";
        const style = document.createElement("style");
        style.innerHTML = css;
        document.head.appendChild(style);
        window.print();
        document.head.removeChild(style);
      }, 3000); // Wait 2.5 seconds before printing
    } else {
      const css = "@page { margin-top: 30px; margin-bottom: 30px }";
      const style = document.createElement("style");
      style.innerHTML = css;
      document.head.appendChild(style);
      window.print();
      document.head.removeChild(style);
    }
  };


  const colums = [
    {
      title: '#',
      dataIndex: 'index',
      key: 'index',
      width: 40,
      render: (text, record, index) => {
        return index + 1;
      },
    },
    {
      title: <span className="bold-title">Product Information</span>,
      children: [
        {
          title: "Gender",
          dataIndex: "gender_name",
          key: "gender_name",
          ...sorterHelper('gender_name'),
        },
        {
          title: "SKU",
          dataIndex: "item_code",
          key: "item_code",
          ...sorterHelper('item_code'),
        },
        {
          title: "Style",
          dataIndex: "style_name",
          key: "style_name",
          ...sorterHelper('style_name'),
        },
        {
          title: "Wash",
          dataIndex: "wash_name",
          key: "wash_name",
          ...sorterHelper('wash_name'),
        },
        {
          title: "Fabric",
          dataIndex: "fabric_name",
          key: "fabric_name",
          ...sorterHelper('fabric_name'),
        },
        {
          title: "Inseam",
          dataIndex: "inseam",
          key: "inseam",
          ...sorterHelper('inseam'),
        },
      ]
    },

    {
      title: <span className="bold-title">Production</span>,
      children: [
        {
          title: "BO #",
          dataIndex: "bulk_order_no",
          key: "bulk_order_no",
          ...sorterHelper('bulk_order_no'),
        },
        {
          title: "BO Date",
          dataIndex: "bo_date",
          key: "bo_date",
          render: (text, record) => {
            return <>{moment(record.bo_date).format("MM-DD-YY")}</>
          },
          ...sorterHelper('bo_date'),
        },
        {
          title: "BO Qty",
          dataIndex: "bulk_quantity",
          key: "bulk_quantity",
          align: "right",
          ...sorterHelper('bulk_quantity', 'num'),
        },
        {
          title: "Bal Qty",
          dataIndex: "sum_quantity",
          key: "sum_quantity",
          align: "right",
          ...sorterHelper('sum_quantity', 'num'),
        },
        {
          title: "Status",
          dataIndex: "stage",
          key: "stage",
          ...sorterHelper('stage'),
        },
        {
          title: "IN Date",
          dataIndex: "adm_in_date",
          key: "adm_in_date",
          render: (text, record) => {
            return <>{moment(record.adm_in_date).format("MM-DD-YY")}</>
          },
          ...sorterHelper('adm_in_date'),

        },
        {
          title: "Ex Factory",
          dataIndex: "adm_ex_factory_date",
          key: "adm_ex_factory_date",
          render: (text, record) => {
            return <>{moment(record.adm_ex_factory_date).format("MM-DD-YY")}</>
          },
          ...sorterHelper('adm_ex_factory_date'),
        },
        {
          title: "Age",
          dataIndex: "adm_ex_factory_date_age",
          key: "adm_ex_factory_date_age",
          ...sorterHelper('adm_ex_factory_date_age','num'),
        },
        {
          title: "Ext Date",
          dataIndex: "adm_extensiondate",
          key: "adm_extensiondate",
          render: (text, record) => {
            return <>{moment(record.adm_extensiondate).format("MM-DD-YY")}</>
          },
          ...sorterHelper('adm_extensiondate'),
        },
        {
          title: "Age",
          dataIndex: "adm_extensiondate_age",
          key: "adm_extensiondate_age",
          ...sorterHelper('adm_extensiondate_age','num'),
        },
        {
          title: "Shipper",
          dataIndex: "ship_via_description",
          key: "ship_via_description",
          ...sorterHelper('ship_via_description'),
        },
        {
          title: "Status",
          dataIndex: "status",
          key: "status",
          ...sorterHelper('status'),
        },
        {
          title: "Reason",
          dataIndex: "reason",
          key: "reason",
          ...sorterHelper('reason'),
        },
      ]
    },
  ];


  // const handleGender = (gender_id) => {
  //   dispatch(getGenderCategoryChange(token, gender_id));
  //   dispatch(getStyleChange(token, gender_id, null, null));
  //   form.setFieldsValue({
  //     gender_category_id: "All",
  //     style_id: "All",
  //     sku: "All"
  //   })
  // }


  // const handleStyle = (gender_category_id) => {
  //   dispatch(getStyleChange(token, form.getFieldValue().gender_id, gender_category_id, null))
  //   form.setFieldsValue({
  //     style_id: "All",
  //     sku: "All"
  //   })
  // }

  const handleSku = (sku_id) => {
    if (sku_id === null) {
      dispatch(getSku(token, null, null, null));
    } else {
      dispatch(getSku(token, form.getFieldValue().gender_id, form.getFieldValue().gender_category_id, sku_id));
    }
    form.setFieldsValue({
      sku: "All"
    })
  }

  function debounce(cb, delay = 1000) {
    let timeout
    return (...args) => {
      clearTimeout(timeout)
      timeout = setTimeout(() => {
        cb(...args)
      }, delay)
    }
  }



  const handleSkuSearch = () => {
    dispatch(getSku(token, null, null, null));
  }

  const optimizedFn = useCallback(debounce(handleSkuSearch), []);


  function downloadExcelFileData(data) {
    setExcelData(
      data.map((v) => {
        return {
          "Gender": v.gender_name,
          "SKU": v.item_code,
          "Style": v.style_name,
          "Wash": v.wash_name,
          "Fabric": v.fabric_name,
          "Inseam": v.inseam,

          "BO #": v.bulk_order_no,
          "BO Date": moment(v.bo_date).format("MM-DD-YYYY"),
          "BO Qty": v.bulk_quantity,
          "Bal Qty": v.sum_quantity,
          "Status": v.stage,
          "IN Date": moment(v.adm_in_date).format("MM-DD-YYYY"),
          "Ex Factory": moment(v.adm_ex_factory_date).format("MM-DD-YYYY"),
          "Age": v.adm_ex_factory_date_age,
          "Ext Date": moment(v.adm_extensiondate).format("MM-DD-YYYY"),
          "Age ": v.adm_extensiondate_age,
          "Shipper": v.ship_via_description,
          "Status ": v.status,
          "Reason": v.reason,
        };
      })
    )
  }


  function downloadPDF(data) {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "pt",
      format: "a4"
    });

    const columns = [
      { header: "#", dataKey: "#" },
      { header: "Gender", dataKey: "gender" },
      { header: "SKU", dataKey: "sku" },
      { header: "Style", dataKey: "style" },
      { header: "Wash", dataKey: "wash" },
      { header: "Fabric", dataKey: "fabric" },
      { header: "Inseam", dataKey: "inseam" },

      { header: "BO #", dataKey: "boNo" },
      { header: "BO Qty", dataKey: "boQty" },
      { header: "Bal Qty", dataKey: "balQty" },
      { header: "Status", dataKey: "status" },
      { header: "IN Date", dataKey: "inDate" },
      { header: "Ex Factory", dataKey: "exFactory" },
      { header: "Age", dataKey: "age" },
      { header: "Ext Date", dataKey: "extDate" },
      { header: "Age (Ext)", dataKey: "ageExt" },
      { header: "Shipper", dataKey: "shipper" },
      { header: "Status (Ext)", dataKey: "statusExt" },
      { header: "Reason", dataKey: "reason" }
    ];

    const rows = data.map((v, index) => ({
      "#": index + 1,
      gender: v.gender_name,
      sku: v.item_code,
      style: v.style_name,
      wash: v.wash_name,
      fabric: v.fabric_name,
      inseam: v.inseam,

      boNo: v.bulk_order_no,
      boQty: v.bulk_quantity,
      balQty: v.sum_quantity,
      status: v.stage,
      inDate: moment(v.adm_in_date).format("MM-DD-YYYY"),
      exFactory: moment(v.adm_ex_factory_date).format("MM-DD-YYYY"),
      age: v.adm_ex_factory_date_age,
      extDate: moment(v.adm_extensiondate).format("MM-DD-YYYY"),
      ageExt: v.adm_extensiondate_age,
      shipper: v.ship_via_description,
      statusExt: v.status,
      reason: v.reason
    }));

    autoTable(doc, {
      columns: columns,
      body: rows,
      styles: {
        fontSize: 6,
        cellPadding: 2
      },
      headStyles: {
        fillColor: [224, 230, 237],
        textColor: [60, 60, 60],
        halign: "center"
      },
      columnStyles: {
        "#": { halign: "center" },
        gender: { halign: "center" },
        sku: { halign: "center" },
        style: { halign: "center" },
        wash: { halign: "center" },
        fabric: { halign: "center" },
        inseam: { halign: "center" },
        boNo: { halign: "center" },
        boQty: { halign: "right" },
        balQty: { halign: "right" },
        status: { halign: "center" },
        inDate: { halign: "center" },
        exFactory: { halign: "center" },
        age: { halign: "center" },
        extDate: { halign: "center" },
        ageExt: { halign: "center" },
        shipper: { halign: "center" },
        statusExt: { halign: "center" },
        reason: { halign: "center" }
      },
      tableWidth: "auto",
      margin: { left: 10, right: 10, top: 10 },
      theme: "grid"
    });

    doc.save("Production-UnFinished-Report.pdf");
  }

  const totalQuantity = () => {
    let sumQty = productionList.reduce(function (previousValue, currentValue) {
      return previousValue += Number(currentValue.sum_quantity);
    }, 0);
    return sumQty;
  }
  const totalQuantityBO = () => {
    let sumQtyBO = productionList.reduce(function (previousValue, currentValue) {
      return previousValue += Number(currentValue.bulk_quantity);
    }, 0);
    return sumQtyBO;
  }

  const handleClear = () => {
    form.resetFields([
      "gender_id",
      "wash_id",
      "sku",
      "style_id",
      "current_season_id",
      "shipper",
      "reason",
      "stage",
      "status",
    ]);
  };


  return (
    <div className="header_class business_header_oms">
      <div className="row justify-content-between business_class_oms distributor">
        <div className="col-3 d-flex align-items-start box-space">
          <div className="logobrand">
            <img id="ImgLogo" alt="logo" src={logo} />
          </div>
        </div>
        <div className="col-4 box-space right-content-header text-right">
          <div className=" d-flex justify-content-end">
            <div className=" d-flex justify-content-end mr-8 printing_class">
              <div className="print_icon printing_class">
                <i
                  onClick={handlePrint}
                  id="Image1"
                  title="Print"
                  alt="Print"
                  src={btnPrint}
                  className="fa-solid fa-print"
                ></i>
              </div>
              <div className="print_icon printing_class">
                <CSVLink
                  filename={"Production-Report.csv"}
                  data={excelData}
                  onClick={() => {
                  }}
                >
                  <input
                    type="image"
                    name="ImgExcel"
                    alt="Export to excel"
                    id="ImgExcel"
                    title="Export to excel"
                    src={xlsx}
                  />
                </CSVLink>

              </div>
            </div>
            <span style={{ fontSize: "small", fontWeight: "bolder" }}>
              Production Report
              <br />
              Rpt # 489
              <br />
              <p className=" mb-0">Rpt # 001_V4</p>
              Login as:{" "}
              <span id="lblSalesPerson" style={{ fontWeight: "bold" }}>
                {userName}
              </span>
            </span>
          </div>
        </div>
      </div>
      <div className="business_class_oms mb-2 distributor">
        <Form form={form} name="control-hooks" onFinish={onFinish}>
          <div className="main_form row">
            <div className="col-12">
              <hr className="my-1" />
              <div className="row">
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">Gender</label>
                    <div className="w-100">
                      <Form.Item name="gender_id" initialValue={"All"}>
                        <Select
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                          defaultValue={"All"}
                        // onChange={(e) => {
                        //   console.log("eeeeeeeeeee", e);
                        //   setIsGenerate(e);
                        // }}
                        >
                          <Option value={null}>All</Option>
                          {gender &&
                            gender?.payload?.data.map((it, index) => {
                              return (
                                <Option key={index} value={it.gender_id}>
                                  {it.gender_name}
                                </Option>
                              );
                            })}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">Wash</label>
                    <div className="w-100">
                      <Form.Item name="wash_id" initialValue={"All"}>
                        <Select
                          defaultValue={form.getFieldValue().wash_id}
                          className={"select_Inputs"}
                          showSearch

                          optionFilterProp="children"
                          size="small"
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          filterSort={(optionA, optionB) =>
                            optionB?.value !== null ?
                              optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                          }
                        >
                          <Option value={null}>All</Option>
                          {wash &&
                            wash?.payload?.data?.map(
                              (status, index) => {
                                return (
                                  <Option
                                    key={status.wash_id}
                                    value={status.wash_id}
                                  >
                                    {status.wash_name}
                                  </Option>
                                );
                              }
                            )}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">Style</label>
                    <div className="w-100">
                      <Form.Item initialValue={"All"} name="style_id">
                        <Select
                          className={"select_Inputs"}
                          showSearch

                          optionFilterProp="children"

                          size="small"
                          onChange={(e) => handleSku(e)}
                          filterSort={(optionA, optionB) =>
                            optionB?.value !== null ?
                              optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                          }
                        >
                          <Option value={null}>All</Option>
                          {
                            styleChange && styleChange?.payload?.data.length >= 0 ? (
                              styleChange && styleChange?.payload?.data.map((style, index) => {
                                return (
                                  <Option key={index} value={style.style_id}>
                                    {style.style_name}
                                  </Option>
                                );
                              })
                            ) : (
                              style && style?.payload?.data.map((style, index) => {
                                return (
                                  <Option key={index} value={style.style_id}>
                                    {style.style_name}
                                  </Option>
                                );
                              })
                            )
                          }
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">Sku</label>
                    <div className="w-100">
                      <Form.Item name="sku" initialValue={"All"}>
                        <Select
                          notFoundContent={Sku.loading ? <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <Loader type="Oval" color="#3c4b58" height={20} width={20} />
                          </div> : <div style={{ display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center" }}>No Data</div>}
                          className={"select_Inputs"}
                          showSearch
                          onSearch={(value) => {
                            optimizedFn(value)
                          }}
                          defaultValue={"All"}
                          // onChange={(e) => {
                          //   console.log("eeeeeeeeeee", e);
                          //   setIsSKU(e);
                          // }}
                          optionFilterProp="children"
                          size="small"
                        >
                          <Option value="All">All</Option>
                          {Sku &&
                            Sku?.payload?.data.map((it, index) => {
                              return (

                                <Option key={index} value={it.sku}>
                                  {it.sku}
                                </Option>
                              );
                            })}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
              </div>
              <div className="main_form row form-margin">
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">Season</label>
                    <div className="w-100">
                      <Form.Item name="current_season_id" initialValue={"All"}>
                        <Select
                          defaultValue={form.getFieldValue().current_season_id}
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          filterSort={(optionA, optionB) =>
                            optionB?.value !== null ?
                              optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                          }
                        >
                          <Option value={null}>All</Option>
                          {season &&
                            season?.payload?.data?.map(
                              (status, index) => {
                                return (
                                  <Option
                                    key={status.season_id}
                                    value={status.season_id}
                                  >
                                    {status.season_name}
                                  </Option>
                                );
                              }
                            )}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">Shipper</label>
                    <div className="w-100">
                      <Form.Item
                        name="shipper"
                        className="full_date"
                        initialValue={"All"}
                      >
                        <Select size="small" style={{ width: "100%" }}>
                          <Option value={null}>All</Option>
                          <Option value="SEA">SEA</Option>
                          <Option value="AIR">AIR</Option>
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">Reason</label>
                    <div className="w-100">
                      <Form.Item
                        name="reason"
                        className="full_date"
                        initialValue={"All"}
                      >
                        <Select
                          defaultValue={form.getFieldValue().production_reason_id}
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                        >
                          <Option value={null}>All</Option>
                          {productionReason &&
                            productionReason?.payload?.data?.map(
                              (item, index) => {
                                return (
                                  <Option
                                    key={item.production_reason_id}
                                    value={item.production_reason_id}
                                  >
                                    {item.production_reason_name}
                                  </Option>
                                );
                              }
                            )}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">Stage</label>
                    <div className="w-100">
                      <Form.Item
                        name="stage"
                        className="full_date"
                        initialValue={"All"} // <-- DEFAULT VALUE SET HERE
                      >
                        <Select size="small" style={{ width: "100%" }}>
                          <Option value={null}>All</Option>
                          <Option value="GGT1">GGT1</Option>
                          <Option value="GGT2">GGT2</Option>
                          <Option value="Cutting">Cutting</Option>
                          <Option value="Stitching">Stitching</Option>
                          <Option value="Washing">Washing</Option>
                          <Option value="Finishing">Finishing</Option>
                          <Option value="Packing">Packing</Option>
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">Status</label>
                    <div className="w-100">
                      <Form.Item
                        name="status"
                        className="full_date"
                        initialValue={"All"} // <-- DEFAULT VALUE SET HERE
                      >
                        <Select size="small" style={{ width: "100%" }}>
                          <Option value={null}>All</Option>
                          <Option value="HOLD">HOLD</Option>
                          <Option value="CUT">CUT</Option>
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-1">
                  <div className=" d-flex flex-row align-items-baseline">
                    {/* <label className=" no_visibility">none</label> */}
                    <div className="w-100" style={{ marginTop: "4px" }}>
                      <Button
                        type="primary"
                        htmlType="submit"
                        className="submit-btn-btm m-0 "
                      >
                        Generate
                      </Button>
                    </div>
                  </div>
                </div>
                <div
                  className="col-12 col-md-3"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginTop: "3px",
                    float: "right",
                  }}
                >
                  <Button
                    style={{ width: "fit-content" }}
                    type="primary"
                    // htmlType="submit"
                    className="submit-btn-btm m-0"
                    onClick={handleClear}
                  >
                    Reset
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </div>
      <div
        className="table_content international_order"

      // style={{ maxWidth: "1400px" }}
      >
        <div   >
          {

          }
          {productionUnFinished?.payload?.data !== undefined ?
            (
              productionUnFinished?.payload?.data.length > 0 ? (
                <Table
                  className="border-line-th  bottom-align-th  table-td-border-right  th-general-style  
              td-general-style even-tr-style border omsTable"
                  ref={tableRef}
                  size="small"
                  bordered={false}
                  type="company"
                  headerClassName='abc'
                  dataSource={productionList}
                  columns={colums}
                  loading={productionUnFinished.loading}
                  pagination={{ pageSize: 500 }}
                  scroll={{ x: 'max-content' }}
                  summary={(pageData) => {
                    let BOQuantity = pageData.reduce(function (
                      previousValue,
                      currentValue
                    ) {
                      return (previousValue += parseFloat(
                        currentValue.bulk_quantity
                      ));
                    },
                      0);
                    let BalQuantity = pageData.reduce(function (
                      previousValue,
                      currentValue
                    ) {
                      return (previousValue += parseFloat(
                        currentValue.sum_quantity
                      ));
                    },
                      0);
                    return (
                      <>
                        <Table.Summary.Row>
                          <Table.Summary.Cell colSpan={2}>Total BO Qty : {numeral(totalQuantityBO()).format("0,00,0")}
                          </Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell>
                            <p style={{ textAlign: "right" }} className="totalquantity">
                              {BOQuantity.toLocaleString("en-US")}
                            </p>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell>
                            <p style={{ textAlign: "right" }} className="totalquantity">
                              {BalQuantity.toLocaleString("en-US")}
                            </p>
                          </Table.Summary.Cell>
                        </Table.Summary.Row>
                        <Table.Summary.Row>
                          <Table.Summary.Cell colSpan={2}>Total BAL Qty : {numeral(totalQuantity()).format("0,00,0")}
                          </Table.Summary.Cell>
                        </Table.Summary.Row>
                      </>
                    );
                  }}
                />
              ) : (
                <div className="no-Data">
                  {/* {} */}
                  <h1>No Data</h1>
                </div>
              )
            ) : (
              loading && (
                <div className="loader" style={{ marginTop: "20px" }}>
                  <Spin size="medium" />
                </div>
              )
            )
          }
        </div>
      </div>
    </div>
  );
};

export default ProductionUnFinished;
